export default {
  productRefurbishedPriceLabel: {
    id: 'product_page_refurbished_price_label',
    defaultMessage: 'Refurbished price',
  },
}
